import { SubscriptionUpdateAnchor } from 'dy-frontend-http-repository/lib/modules/Subscription/enums';

const updateAnchorInformation: { [anchor in SubscriptionUpdateAnchor]: string } = {
    [SubscriptionUpdateAnchor.NOW]: 'Now',
    [SubscriptionUpdateAnchor.MANUAL]: 'Custom date',
    [SubscriptionUpdateAnchor.CURRENT_PERIOD_END]: 'At the end of current period',
};
export default updateAnchorInformation;
